export const INSTRUCTIONS = [
  "Open the GemLightBox app on your phone",
  "Go to Settings - and click on the “Link Device” button",
  "Point your phone at this screen to confirm login ",
];

export const SIGN_IN_ERROR = "signin:not_confirmed";

export const UNIQUE_ID_SEPARATOR = "0";
